import React, { useEffect, useState, useContext } from 'react';
import SideNav from '../shared/SideNav'
import Breadcrumb from '../../shared/Breadcrumb';
import axios from 'axios';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import { apiRoutes } from '../../../AppSettings';
import { Form } from 'react-bootstrap';
import alertify from "alertifyjs";

const PatientProfileSetting = () => {
	const { userState } = useContext(AuthContext);
	const [patient, setPatient] = useState(userState.loggedInUser);
	const loggedInPatientId = userState.user.userId;

	const updatePatient = (data) => {
		setPatient(data);
	};

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer ' + userState.token
		}
	};

	const handleSubmit = e => {
		e.preventDefault();
		axios.post(apiRoutes.UpdatePatient, JSON.stringify(patient), options)
			.then((response) => {
				if (response.status === 200) {
					const data = response.data;
					//updateUserState(data.token, data.userDetail, true, data.roles[0]);
					console.log(data);
					alertify.success("Profile updated successfully");
				}
			}, (error) => {
				alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
			});
	};

	const getFiles = (e) => {
		if (e.target.files[0].size <= 2097152) {
			var reader = new FileReader();
			reader.onload = function (upload) {
				updatePatient({ ...patient, profileImage: upload.target.result })
			};
			reader.readAsDataURL(e.target.files[0]);
		}
	}

	return (
		<div>
			<Breadcrumb title="Profile Settings" />
			<div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<SideNav applyCssFor='profilesetting' user={patient} />
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="card">
								<div className="card-body">
									<Form onSubmit={(e) => handleSubmit(e)}>
										<div className="row form-row">
											<div className="col-12 col-md-12">
												<div className="form-group">
													<div className="change-avatar">
														<div className="profile-img">
															<img src={Util.loadImage(patient.profileImage)} alt="User Image" />
														</div>
														<div className="upload-img">
															<div className="change-photo-btn">
																<span><i className="fa fa-upload"></i> Upload Photo</span>
																<input type="file" className="upload"

																	onChange={getFiles}
																	accept="image/*" />

															</div>
															<small className="form-text text-muted">Allowed JPG, GIF or PNG. Max size of 2MB</small>
														</div>
													</div>
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>First Name</label>
													<input type="text" className="form-control" required value={patient.firstName}
														onChange={e => setPatient({ ...patient, firstName: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Last Name</label>
													<input type="text" className="form-control" required value={patient.lastName}
														onChange={e => setPatient({ ...patient, lastName: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Date of Birth</label>
													<div className="cal-icon">
														<input type="text" className="form-control datetimepicker" required value="24-07-1983" />
													</div>
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Blood Group</label>
													<select className="form-control select" required value={patient.bloodGroup}>
														<option>A-</option>
														<option>A+</option>
														<option>B-</option>
														<option>B+</option>
														<option>AB-</option>
														<option>AB+</option>
														<option>O-</option>
														<option>O+</option>
													</select>
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Email ID</label>
													<input type="email" className="form-control" required value={patient.emailAddress}
														onChange={e => setPatient({ ...patient, emailAddress: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Mobile</label>
													<input type="text" className="form-control" required value={patient.phone}
														onChange={e => setPatient({ ...patient, phone: e.target.value })} />
												</div>
											</div>
											<div className="col-12">
												<div className="form-group">
													<label>Address</label>
													<input type="text" className="form-control" required value={patient.address}
														onChange={e => setPatient({ ...patient, address: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>City</label>
													<input type="text" className="form-control" required value={patient.city}
														onChange={e => setPatient({ ...patient, city: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>State</label>
													<input type="text" className="form-control" required value={patient.state}
														onChange={e => setPatient({ ...patient, state: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Zip Code</label>
													<input type="text" className="form-control" required value={patient.zipCode}
														onChange={e => setPatient({ ...patient, zipCode: e.target.value })} />
												</div>
											</div>
											<div className="col-12 col-md-6">
												<div className="form-group">
													<label>Country</label>
													<input type="text" className="form-control" required value={patient.country}
														onChange={e => setPatient({ ...patient, country: e.target.value })} />
												</div>
											</div>
										</div>
										<div className="submit-section">
											<button type="submit" className="btn btn-primary submit-btn">Save Changes</button>
										</div>
									</Form>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>

	);
}

export default PatientProfileSetting;